import { observer } from 'mobx-react-lite'
import { useRef, useState } from 'react'
import classnames from 'classnames'
import { DraggableWrapper } from 'shared/ui'
import { useEventCallQueueParticipantJoin } from 'widgets/CallPopUp/events/EventCallQueueParticipantJoin'
import { useEventCallQueueParticipantLeave } from 'widgets/CallPopUp/events/EventCallQueueParticipantLeave'
import { CallPopUpDefault } from 'widgets/CallPopUp/ui/CallPopUpDefault'
import styles from 'widgets/CallPopUp/ui/styles.module.scss'
import { useCallPopUpGlobalContext } from 'widgets/CallPopUp/context/callPopUpGlobalContext'

export const CallPopUp = observer(() => {
  const callPopUpGlobalStore = useCallPopUpGlobalContext()
  const [isScroll, setIsScroll] = useState(false)
  const draggleRef = useRef<HTMLDivElement>(null)

  useEventCallQueueParticipantLeave(callPopUpGlobalStore)
  useEventCallQueueParticipantJoin(callPopUpGlobalStore)

  const popupWidth = 332
  const windowWidth = window.innerWidth
  const position = {
    x: Math.abs(windowWidth - popupWidth),
    y: 0,
  }

  const hasActiveCall = !callPopUpGlobalStore.callStore.isStatusClose
  const activeInboxId = callPopUpGlobalStore.callStore.contactFrom?.id ?? null
  const visibleItems = callPopUpGlobalStore.itemsSort.filter((item) => {
    if (item.view === 'queue') return true
    if (item.isPowerDialerRunning) return true
    if (!hasActiveCall || activeInboxId === null) return true
    return item.id === activeInboxId
  })

  if (!visibleItems.length || callPopUpGlobalStore.isExternalSourcePipedrive) return null

  return (
    <DraggableWrapper
      draggleRef={draggleRef}
      defaultPosition={position}
      onChangeRef={(element) => {
        setIsScroll(element.offsetHeight < element.scrollHeight)
      }}
    >
      {(ref) => {
        return (
          <div
            ref={ref}
            className={classnames(styles.scroll, {
              [styles['scroll--enable']]: isScroll,
            })}
          >
            {visibleItems.map((item) => {
              return <CallPopUpDefault key={`${item.id}_${item.status}`} store={item.store} />
            })}
          </div>
        )
      }}
    </DraggableWrapper>
  )
})
